import EventEmitter from "eventemitter3";
import detect from "@jam3/detect";

export default class TouchControls extends EventEmitter {
  constructor(element, options) {
    super();
    this.element = element;
    this.pointers = [];
    this.options = Object.assign(
      {
        hover: false, // mouse only
        touchStart: true,
        touchMove: true,
        touchEnd: true,
      },
      options
    );
    this.touchesLength = 0;
    this.isDown = false;
    this.bindEvents(true);
  }

  bindEvents = (bind) => {
    const listener = bind ? "addEventListener" : "removeEventListener";
    const isDesktop = detect.device.isDesktop;

    if (this.options.touchStart)
      this.element[listener](
        isDesktop ? "mousedown" : "touchstart",
        this.onTouchStart
      );
    if (this.options.touchMove)
      this.element[listener](
        isDesktop ? "mousemove" : "touchmove",
        this.onTouchMove
      );
    if (this.options.touchEnd)
      this.element[listener](
        isDesktop ? "mouseup" : "touchend",
        this.onTouchEnd
      );
    if (isDesktop) {
      if (this.options.hover)
        this.element[listener]("mouseover", this.onMouseOver);
      if (this.options.hover)
        this.element[listener]("mouseout", this.onMouseOut);
    }
  };

  setPointers = (event) => {
    this.pointers = [];
    if (event.touches) {
      this.touchesLength = event.touches.length;
      for (let i = 0; i < this.touchesLength; i++) {
        const pointer = event.touches[i];
        this.pointers.push({
          x: pointer.pageX,
          y: pointer.pageY,
          normalX: pointer.pageX / window.innerWidth,
          normalY: pointer.pageY / window.innerHeight,
        });
      }
    } else {
      this.pointers.push({
        x: event.pageX,
        y: event.pageY,
        normalX: event.pageX / window.innerWidth,
        normalY: event.pageY / window.innerHeight,
      });
    }
  };

  onTouchStart = (event) => {
    this.isDown = true;
    this.setPointers(event);
    this.emit("start", this.pointers);
  };

  onTouchMove = (event) => {
    this.onMouseMove(event);
    if (!this.isDown) return;
    this.setPointers(event);
    this.emit("move", this.pointers);
  };

  onTouchEnd = () => {
    this.isDown = false;
    this.emit("end", this.pointers);
  };

  onMouseMove = (event) => {
    this.setPointers(event);
    this.emit("mousemove", this.pointers);
  };

  onMouseOver = (event) => {
    this.emit("hover", true);
  };

  onMouseOut = (event) => {
    this.emit("hover", false);
  };

  dispose = () => {
    this.bindEvents(false);
  };
}
